/*
 *
 *  sagas
 *
 */

import { call, take, put, race, all } from "redux-saga/effects";

import {
  LOAD_PAYMENT_OUT_DETAILS_RECORDS_META_DATA,
  LOAD_PAYMENT_OUT_DETAILS,
  CREATE_PAYMENT_OUT_DETAILS,
  UPDATE_PAYMENT_OUT_DETAILS,
  DELETE_PAYMENT_OUT_DETAILS,
  LOAD_PAYMENT_OUT_SETTLED_LIST,
  LOAD_PAYMENT_OUT_DETAILS_REPORT,
} from "./constants";

import {
  loadPaymentOutList,
  loadPaymentOutListSuccess,
  loadPaymentOutListError,
  createPaymentOutListSuccess,
  createPaymentOutListError,
  updatePaymentOutListSuccess,
  updatePaymentOutListError,
  deletePaymentOutListSuccess,
  deletePaymentOutListError,
  loadPaymentOutListRecordsMetaDataError,
  loadPaymentOutListRecordsMetaDataSuccess,
  loadPaymentSettledList,
  loadPaymentSettledListSuccess,
  loadPaymentSettledListError,
  loadPaymentOutReportList,
  loadPaymentOutReportListSuccess,
  loadPaymentOutReportListError,
} from "./actions";

import {
  loadPaymentOutDetails,
  createPaymentOutDetails,
  updatePaymentOutDetails,
  deletePaymentOutDetails,
  loadRecordsMetaData,
  loadPaymentSettledDetails,
  loadPaymentOutReportDetails,
} from "./remotes";
// import { isEmpty } from "lodash";

function* loadPaymentOutListSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_PAYMENT_OUT_DETAILS),
    });

    const { explicitLoad } = load;
    const { paymentDetails } = explicitLoad || {};
    yield put(loadPaymentOutList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadPaymentOutDetails, paymentDetails);

        if (result) {
          yield put(loadPaymentOutListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadPaymentOutListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadPaymentSettledDetailsSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_PAYMENT_OUT_SETTLED_LIST),
    });

    const { explicitLoad } = load;
    const { paymentDetails } = explicitLoad || {};
    yield put(loadPaymentSettledList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadPaymentSettledDetails, paymentDetails);

        if (result) {
          yield put(loadPaymentSettledListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadPaymentSettledListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* createPaymentSaga() {
  while (true) {
    const { create } = yield race({
      create: take(CREATE_PAYMENT_OUT_DETAILS),
    });

    const { paymentDetails } = create || {};

    if (create) {
      try {
        const result = yield call(createPaymentOutDetails, paymentDetails);
        if (result) {
          yield put(createPaymentOutListSuccess(result.data));
          // console.log(result.data, "result");
        }
      } catch (error) {
        yield put(
          createPaymentOutListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* updatePaymentSaga() {
  while (true) {
    const { update } = yield race({
      update: take(UPDATE_PAYMENT_OUT_DETAILS),
    });
    const { paymentDetails } = update || {};

    if (update) {
      try {
        const result = yield call(updatePaymentOutDetails, paymentDetails);
        if (result) {
          yield put(updatePaymentOutListSuccess(result.data));
          // console.log(result.data, "result");
        }
      } catch (error) {
        yield put(
          updatePaymentOutListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}
function* deletePaymentSaga() {
  while (true) {
    const { create } = yield race({
      create: take(DELETE_PAYMENT_OUT_DETAILS),
    });
    const { paymentDetails } = create || {};

    if (create) {
      try {
        const result = yield call(deletePaymentOutDetails, paymentDetails);
        if (result) {
          yield put(deletePaymentOutListSuccess(result.data));
          // console.log(result.data, "result");
        }
      } catch (error) {
        yield put(
          deletePaymentOutListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}


function* loadPaymentOutReportSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_PAYMENT_OUT_DETAILS_REPORT),
    });

    const { explicitLoad } = load;
    const { paymentDetails } = explicitLoad || {};
    yield put(loadPaymentOutReportList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadPaymentOutReportDetails, paymentDetails);

        if (result) {
          yield put(loadPaymentOutReportListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadPaymentOutReportListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadPaymentDetailsMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({
      metaData: take(LOAD_PAYMENT_OUT_DETAILS_RECORDS_META_DATA),
    });

    try {
      const paymentMode = yield call(
        loadRecordsMetaData,
        "getpaymentmode",
        "post"
      );

      let recordsMetaData = {
        paymentModeOptions:
          (paymentMode &&
            paymentMode &&
            paymentMode.length > 0 &&
            paymentMode.map((c) =>
              Object.assign(
                {},
                {
                  label: c.paymentModeName,
                  shortCode: c.shortCode,
                  value: c._id,
                }
              )
            )) ||
          [],
      };

      yield put(loadPaymentOutListRecordsMetaDataSuccess(recordsMetaData));
    } catch (error) {
      yield put(
        loadPaymentOutListRecordsMetaDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      );
    }
  }
}

export default function* recordsSaga() {
  yield all([
    loadPaymentOutListSaga(),
    loadPaymentOutReportSaga(),
    loadPaymentSettledDetailsSaga(),
    deletePaymentSaga(),
    updatePaymentSaga(),
    createPaymentSaga(),
    loadPaymentDetailsMetaDataSaga(),
  ]);
}
